import axios from "axios";
import qs from "qs";
//将所有的主机名和端口 一起设置
// axios.defaults.baseURL = "crmapi.kidcastle.org";
import Urls from "../../urlLink";
import {isGraySchoolEnabled} from "@/bootstrap/graySchoolRouting";
const root = Urls.crmApiUrl; //域名
//首页数据请求
const url = {
  getSellgoal: root + "/Sellgoal",
  getgoalOne: root + "/Sellgoal/goalOneApi",
  goalCheckMarketer: root + "/Sellgoal/goalCheckMarketerApi",
  goalFinishStatus: root + "/Sellgoal/goalFinishStatusApi",
  goalFinishRate: root + "/Sellgoal/goalFinishRateApi",
  addGoal: root + "/Sellgoal/addGoalAction",
  updateGoal: root + "/Sellgoal/updateGoalAction",
  getgoalMy: root + "/Sellgoal/goalMy",
  getsellActivity: root + "/Sellgoal/sellActivity",
  getsellActivityExport: root + "/Sellgoal/sellActivity/Export",
  getgoalActivityOne: root + "/Sellgoal/goalActivityOneApi",
  addGoalActivity: root + "/Sellgoal/addGoalActivityAction",
  getgoalFounder: root + "/Sellgoal/goalFounderApi",
  updateGoalActivity: root + "/Sellgoal/updateGoalActivityAction",
  getActivityFounder: root + "/Sellgoal/ActivityFounderApi",
  delGoal: root + "/Sellgoal/delGoalAction",
  delGoalActivity: root + "/Sellgoal/delGoalActivityAction",
  copyActivityOneApi: root + "/Sellgoal/copyActivityOneApi",
  enrollTicketList: root + "/Client/enrollTicketList",
  enrollTicketListExport: root + "/Client/enrollTicketList/Export",
  createEnrollTicketAction: root + "/Client/createEnrollTicketAction",
  freevoucherList: root + "/Client/freevoucherList",
  getShareposterList: root + "/Sellgoal/getShareposterList",
  getShareposterListExport: root + "/Sellgoal/getShareposterList/Export",
  // 跨界活动
  activityList: root + "/Transboundary/activityList", // 跨界活动->CRM-活动列表
  activityRecordList: root + "/Transboundary/activityRecordList", // 跨界活动->CRM-活动参与列表
  activityRecordListExport: root + "/Transboundary/activityRecordList/Export", // 跨界活动->CRM-活动参与列表
  batchSettlementAction: root + "/Transboundary/batchSettlementAction", // CRM-批量结算活动奖励
  closeActivityAction: root + "/Transboundary/closeActivityAction", // 跨界活动->CRM-结束活动
  deleteActivityAction: root + "/Transboundary/deleteActivityAction", // 跨界活动->CRM-删除未开始活动
  editActivityAction: root + "/Transboundary/editActivityAction", // 跨界活动->CRM-编辑未开始活动
  addActivityAction: root + "/Transboundary/addActivityAction", // 跨界活动->CRM-添加跨界活动

  getGroundPromotion: root + "/Sellgoal/getGroundPromotion",
  addGroundPromotionAction: root + "/Sellgoal/addGroundPromotionAction",
  openGroundPromotionAction: root + "/Sellgoal/openGroundPromotionAction",
  editGroundPromotionAction: root + "/Sellgoal/editGroundPromotionAction",
  GroundPromotionQRcodeApi: root + "/Sellgoal/GroundPromotionQRcodeApi",
  getPromotion: root + "/Sellgoal/getPromotion",

  Home: root + "/Client/Home",
  allotTmkClientApi: root + "/Client/allotTmkClientApi",
  changeClientToValidApi: root + "/Client/changeClientToValidApi",
  getTmkImportTrackApi: root + "/Client/getTmkImportTrackApi",
  changeClientToScreenedApi: root + "/Client/changeClientToScreenedApi",
  getActivity: root + "/Client/getActivityApi",
  ImportTrack: root + "/Client/ImportTrack",
  getTmkMarketerApi: root + "/Public/getTmkMarketerApi",
  changeLossClientTmkApi: root + "/Lossclient/changeLossClientTmkApi",
  batchActCoursecatAction: root + "/PhoneActivity/batchActCoursecatAction",

  addInviteIsvisitTrackOne: root + "/Client/addInviteIsvisitTrackOne",
  toInvalidLossClientApi: root + "/Client/toInvalidLossClientApi",
};
const storeCrmActiveManage = {
  // 招生目标管理
  getTmkMarketerApi(params) {
    return axios.get(url.getTmkMarketerApi, { params });
  },
  getSellgoal(params) {
    return axios.get(url.getSellgoal, { params });
  },
  getActivity(params) {
    return axios.get(url.getActivity, { params });
  },
  Home(params) {
    return axios.get(url.Home, { params });
  },
  // 单个招生目标查看
  getgoalOne(params) {
    return axios.get(url.getgoalOne, { params });
  },
  // 参与目标考核的所有员工
  getgoalCheckMarketer(params) {
    return axios.get(url.goalCheckMarketer, { params });
  },
  // 某目标参与成员的线索转正数
  getgoalFinishStatus(params) {
    return axios.get(url.goalFinishStatus, { params });
  },
  // 某目标参与成员的跟踪柜询完成率
  getgoalFinishRate(params) {
    return axios.get(url.goalFinishRate, { params });
  },
  // 目标创建人管理
  getgoalFounder(params) {
    return axios.get(url.getgoalFounder, { params });
  },
  // 目标创建人管理
  getActivityFounder(params) {
    return axios.get(url.getActivityFounder, { params });
  },
  getTmkImportTrackApi(params) {
    return axios.get(url.getTmkImportTrackApi, { params });
  },
  // 添加招生目标
  changeLossClientTmkApi(params) {
    return axios.post(url.changeLossClientTmkApi, qs.stringify(params));
  },
  toInvalidLossClientApi(params) {
    return axios.post(url.toInvalidLossClientApi, qs.stringify(params));
  },
  changeClientToScreenedApi(params) {
    return axios.post(url.changeClientToScreenedApi, qs.stringify(params));
  },
  ImportTrack(params) {
    return axios.post(url.ImportTrack, qs.stringify(params));
  },
  allotTmkClientApi(params) {
    return axios.post(url.allotTmkClientApi, qs.stringify(params));
  },
  changeClientToValidApi(params) {
    return axios.post(url.changeClientToValidApi, qs.stringify(params));
  },
  addGoal(params) {
    return axios.post(url.addGoal, qs.stringify(params));
  },
  // 修改招生目标
  updateGoal(params) {
    return axios.post(url.updateGoal, qs.stringify(params));
  },
  // 删除招生目标
  delGoal(params) {
    return axios.post(url.delGoal, qs.stringify(params));
  },
  // 我的招生目标管理
  getgoalMy(params) {
    return axios.get(url.getgoalMy, { params });
  },
  // 招生活动管理
  getsellActivity(params) {
    return axios.get(url.getsellActivity, { params });
  },
  // 招生活动管理---导出
  getsellActivity1() {
    return isGraySchoolEnabled() ? url.getsellActivityExport:url.getsellActivity;
  },
  // 海报活动->列表 -- 97
  getShareposterList(params) {
    return axios.get(url.getShareposterList, { params });
  },
  // 海报活动->列表 -- 97---导出
  getShareposterList1() {
    return isGraySchoolEnabled() ? url.getShareposterListExport:url.getShareposterList;
  },
  // 招生劵管理***招生名单
  freevoucherList(params) {
    return axios.get(url.freevoucherList, { params });
  },
  // 单个招生活动查看
  getgoalActivityOne(params) {
    return axios.get(url.getgoalActivityOne, { params });
  },
  // 添加招生活动目标
  addGoalActivity(params) {
    return axios.post(url.addGoalActivity, qs.stringify(params));
  },
  // 单个招生活动 修改
  updateGoalActivity(params) {
    return axios.post(url.updateGoalActivity, qs.stringify(params));
  },
  // 单个招生活动 删除
  delGoalActivity(params) {
    return axios.post(url.delGoalActivity, qs.stringify(params));
  },
  // 复制活动
  copyActivityOneApi(params) {
    return axios.post(url.copyActivityOneApi, qs.stringify(params));
  },
  //招生券活动->招生券管理列表
  enrollTicketList(params) {
    return axios.get(url.enrollTicketList, { params });
  },
  //招生券活动->生成招待券
  createEnrollTicketAction(params) {
    return axios.post(url.createEnrollTicketAction, qs.stringify(params));
  },
  // 招生券管理列表--导出
  enrollTicketList1() {
    return isGraySchoolEnabled() ? url.enrollTicketListExport:url.enrollTicketList;
  },
  // 招生券管理列表--导出
  freevoucherList1() {
    return url.freevoucherList;
  },
  // 跨界活动->CRM-活动列表
  activityList(params) {
    return axios.get(url.activityList, { params });
  },
  // 跨界活动->CRM-活动列表 --------导出
  activityList1() {
    return url.activityList;
  },
  // 跨界活动->CRM-活动参与列表
  activityRecordList(params) {
    return axios.get(url.activityRecordList, { params });
  },
  // 跨界活动->CRM-活动参与列表 -----导出
  activityRecordList1() {
    return isGraySchoolEnabled() ? url.activityRecordListExport:url.activityRecordList;
  },
  // CRM-批量结算活动奖励
  batchSettlementAction(params) {
    return axios.post(url.batchSettlementAction, qs.stringify(params));
  },
  // 跨界活动->CRM-结束活动
  closeActivityAction(params) {
    return axios.post(url.closeActivityAction, qs.stringify(params));
  },
  // 跨界活动->CRM-删除未开始活动
  deleteActivityAction(params) {
    return axios.post(url.deleteActivityAction, qs.stringify(params));
  },
  // 跨界活动->CRM-编辑未开始活动
  editActivityAction(params) {
    return axios.post(url.editActivityAction, qs.stringify(params));
  },
  // 跨界活动->CRM-添加跨界活动
  addActivityAction(params) {
    return axios.post(url.addActivityAction, qs.stringify(params));
  },
  getGroundPromotion(params) {
    return axios.get(url.getGroundPromotion, { params });
  },
  GroundPromotionQRcodeApi(params) {
    return axios.get(url.GroundPromotionQRcodeApi, { params });
  },
  getPromotion(params) {
    return axios.get(url.getPromotion, { params });
  },
  addGroundPromotionAction(params) {
    return axios.post(url.addGroundPromotionAction, qs.stringify(params));
  },
  openGroundPromotionAction(params) {
    return axios.post(url.openGroundPromotionAction, qs.stringify(params));
  },
  editGroundPromotionAction(params) {
    return axios.post(url.editGroundPromotionAction, qs.stringify(params));
  },
  batchActCoursecatAction(params) {
    return axios.post(url.batchActCoursecatAction, qs.stringify(params));
  },
  addInviteIsvisitTrackOne(params) {
    return axios.post(url.addInviteIsvisitTrackOne, qs.stringify(params));
  },
};

export default storeCrmActiveManage;
